import React, { useState, useEffect } from 'react';
import client from '@/lib/feathers';
import styles from './index.module.scss';
import BAButton from '../BAButton';
import { Tab } from '@alifd/next';
import Slider from '../Slider';


function BAList() {
  const baDevice = client.service('baDevice');
  const [arrDiv, setArrDiv] = useState([])
  const [groupDataArr, setGroupDataArr] = useState(['全部']);
  const [selectTabName, setSelectTabName] = useState('');
  const [rangeValue, setRangeValue] = useState(0);

  const detachedContentStyle = {
    border: '1px solid #DCDEE3',
    padding: '20px'
  };
  // console.log("groupDataArr",groupDataArr)

 
  const onChangeSlider = e => {
    setRangeValue(parseInt(e.target.value, 0));
 
  }

  function updateMultiState(arr) {//arr:[socket更新的data] || [find All的data]
    console.log('==原baDeviceArr:', arr.map(x => `${x.text}:${x.value}`).join(','))

    setArrDiv((prevState)=>{
      
      let finalArr = [];
      if(prevState.length==0 && arr.length > 0){//[find All的data]
        finalArr = arr;
      }
      else {//[socket更新的data]
        prevState = [...prevState].map(i=>i.props.item);
        const tarNames = [...arr].map((i)=>i.name || false);
        finalArr = [...prevState].map((i)=>{
          if(i.name && tarNames.includes(i.name)){
            const tarChildNb = tarNames.indexOf(i.name);
            return {
              ...i,
              ...arr[tarChildNb]
            }
          }
          return i;
        })
      }
      
      return finalArr.map(x =>
     {
      //  console.log(x.value,typeof x.value)
       if(isNaN(parseInt(x.value)))return (<BAButton key={x._id} item={x} /> )//parseInt("開啟")=NaN
       else {return (<Slider 
       key={x._id}
       item={x}
       min={0}
       max={100}
       step={1}
       defaultLength={x.value}
       value={x.value}
       onChangeValue={onChangeSlider}
       linearGradientColor="#4aa1f3"
       rangeBackgroundColor="#d7dcdf"
       sliderThumbColor="#4aa1f3"
     />)}
     }
          
        
      
      
       
    )
    });

  }
 function renderNewArr(){
   if(selectTabName=="")return arrDiv;
   return [...arrDiv].filter(x=>{
     if(!x.props.item.group)return false;//回傳過濾沒有Group key
     return x.props.item.group===selectTabName;
    })
  
 }
 

  useEffect(() => {

    baDevice.find({query:{
      securityIp:{'$exists':false}
    }}).then((result) => {
      // console.log("result", result.data)
      // call getallstate?
      setGroupDataArr(groupDataArr => [...new Set(groupDataArr.concat(result.data.map(x => x.group)))]);
      updateMultiState(result.data)// 暫時處理


    }).catch((error) => {
      console.log('==原baDeviceArr:', error)
    })


    client.io.on('updatemultistate', arr => {
      console.log('updatemultistate msg:', arr.map(x => `${x.text}:${x.value}`).join(','))
      updateMultiState(arr);

    })
    // client.reAuthenticate().then((data) => {
    //   console.log('==relogin ok', data.user.email);
    // }).catch(err => {
    //   console.log('==relogin fail');
    //   // history.push('/user/login');
    // })
  }, [])
  //   useEffect(() => {
  //     setArrDiv(arrDev.map(x=><BAButton item={x}></BAButton>))
  //   },[arrDev]);



  return (
    <>
    <Tab
      className={styles.tab}
      // lazyLoad={false}
      shape="pure"
      contentStyle={detachedContentStyle}
      onChange={(key) => {
        // console.log(groupDataArr[key])

        if (groupDataArr[key] === '全部') {
          setSelectTabName('')
        } else {
          setSelectTabName(groupDataArr[key])
        }

      }}>
  
        {
          groupDataArr.map((item, index) => <Tab.Item title={item} key={index}>
          <div className={styles.BAList}>{renderNewArr()}</div>
        
          </Tab.Item>)
          
        }

    </Tab>
    

 </> );
}

export default BAList;
